export default function AboutSection() {
  return (
    <section id="about" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">关于春夜</h2>
            <p className="text-sm text-foreground-600">一个只为夜晚而生的观影平台</p>
          </div>
          <div className="bg-background-50 rounded-2xl p-8 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center">
              <div className="flex-1">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  春夜影院诞生于一个简单而温暖的愿望 —— 为每一个喜欢在夜晚安静观影的人，打造一个值得信赖的片单平台。我们相信，夜晚是最适合看电影的时光。没有白天的喧嚣，只有你和屏幕里的光影故事。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  我们的编辑团队每天花费大量时间观看和筛选影片，从浩瀚的影视作品库中挑选出那些真正值得在春夜细细品味的佳作。每一部入选的影片，都经过至少三位编辑的观看和讨论 —— 我们拒绝算法堆砌，坚持用人的眼光为人的夜晚挑选电影。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  目前平台已收录超过 <strong className="text-primary-500">2000 部</strong> 精选电影和剧集，涵盖 <strong className="text-primary-500">20 多个</strong> 主题分类。无论你是想找一部治愈系电影来放松心情，还是一部悬疑片来挑战大脑，抑或是一部浪漫爱情片来温暖春夜，这里都有属于你的那一部。
                </p>
              </div>
              <div className="flex-shrink-0">
                <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20minimalist%20warm%20toned%20illustration%20of%20an%20open%20book%20with%20a%20glowing%20film%20projector%20beam%20emerging%20from%20the%20pages%20creating%20a%20starry%20night%20sky%20scene%2C%20soft%20amber%20and%20cream%20colors%2C%20dreamy%20atmospheric%20quality%2C%20simple%20elegant%20composition%20with%20gentle%20gradients%2C%20artistic%20logo%20style%20illustration%20for%20a%20cinema%20brand&width=400&height=400&seq=about-image&orientation=squarish"
                    alt="春夜影院品牌形象"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}